import formatGameName from '@app/components/custom-links/game-link/helper'
import {GAMEPLAYER_ROUTE} from '@app/constants/global'
import {LanguageCodes} from '@app/i18n/settings'

interface RelativeGamePath {
  lang: LanguageCodes
  gameName: string
  gameCode: string
}

interface FullGameUrl extends RelativeGamePath {
  host: string | null
}

const generateGameUrl = ({host = 'www.gamezop.com', lang, gameName, gameCode}: FullGameUrl) => {
  return `https://${host}${generateRelativeGamePath({lang, gameName, gameCode})}`
}

const generateRelativeGamePath = ({
  lang,
  gameName,
  gameCode,
}: {
  lang: LanguageCodes
  gameName: string
  gameCode: string
}) => {
  return `/${encodeURI(lang)}/${encodeURI(GAMEPLAYER_ROUTE)}/${encodeURI(formatGameName(gameName) || '')}/${encodeURI(
    gameCode,
  )}`
}

export {generateGameUrl, generateRelativeGamePath}
